import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavbarAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#787887" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.987 17.579A3 3 0 0 1 9.75 15.75h4.5a3 3 0 0 1 2.763 1.829M15 10.125a3 3 0 1 1-6 0 3 3 0 0 1 6 0M19.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
    />
  </svg>
);
export default SvgNavbarAccount;
